import React, { useState } from 'react';
import { Mutation } from 'react-apollo';
import Input from '../forms/Input';
import { Caps, Card } from '../ui';
import { invitationsCreateMutation } from '../../queries/invitations';

const InviteForm = () => {
  const [input, setInput] = useState({
    name: '',
    organization: '',
    email: ''
  });
  const [response, setResponse] = useState({ email: '', inviteCode: '' });
  const [error, setError] = useState('');

  function handleChange(event: React.FormEvent<HTMLInputElement>): void {
    const { name, value }: any = event.target;
    const newInput: any = input;
    newInput[name] = value.trim();
    setInput(newInput);
  }

  function handleResponse(res: any) {
    const { invitation } = res.data.createInvitation;
    if (invitation.inviteCode) {
      setResponse({ ...invitation });
      return;
    }
    setError('Oh no. Something went wrong.');
  }

  function reset() {
    setInput({
      name: '',
      organization: '',
      email: ''
    });
    setResponse({
      email: '',
      inviteCode: ''
    });
    setError('');
  }

  console.log(input);
  return (
    <Card style={{ maxWidth: 384 }} className="center">
      {/* The Form */}
      {!response.inviteCode && (
        <Mutation mutation={invitationsCreateMutation} variables={{ input }}>
          {createInvitation => (
            <form
              onSubmit={async e => {
                e.preventDefault();
                const res = await createInvitation();
                handleResponse(res);
              }}
            >
              <div className="ph3 ph4-ns">
                <h1 className="f3 f2-ns display tc mb3 mb4-ns mt3 mt4-ns">Create an Invite</h1>
              </div>

              {error && <p className="br3 serif i ph3 ph4-ns red tc">{error}</p>}

              <div className="ph3 ph4-ns">
                <Input
                  className="mb4"
                  label="Name"
                  placeholder="Koala Bear"
                  name="name"
                  onChange={handleChange}
                  data-testid="invite-name"
                />
                <Input
                  className="mb4"
                  label="Organization"
                  placeholder="Eucalyptus, Inc."
                  name="organization"
                  onChange={handleChange}
                  data-testid="invite-org"
                />
                <Input
                  className="mb4"
                  label="Email"
                  placeholder="koala@eucalyptus.com"
                  name="email"
                  onChange={handleChange}
                  data-testid="invite-email"
                />
              </div>
              <button
                type="submit"
                className="bt b--light-gray w-100 pa3 tc mt3 mt4-ns blue fw5"
                data-testid="create-invite-button"
              >
                Create
              </button>
            </form>
          )}
        </Mutation>
      )}

      {/* Success! */}
      {response.inviteCode && (
        <>
          <div className="ph3 ph4-ns pt3 tc">
            <Caps as="p">Invite Code</Caps>
            <div className="ba b--light-gray bg-snow-white pa3 code">{response.inviteCode}</div>

            <p className="navy">
              <a href={`/register?inviteCode=${response.inviteCode}&email=${response.email}`}>
                Invite Link
              </a>{' '}
              for {response.email}
            </p>
          </div>
          <button
            type="submit"
            className="bt b--light-gray w-100 pa3 tc mt3 mt4-ns blue fw5"
            onClick={reset}
            data-testid="send-another-button"
          >
            Send Another
          </button>
        </>
      )}
    </Card>
  );
};

export default InviteForm;
